import {Modal, Text, Title} from '@mantine/core';
import type {FC} from 'react';
import {MdLogin, MdPersonAdd} from 'react-icons/md';
import {LOGIN} from '../../config/constants/routes';
import {getMailAuthLinkWithParamsHooks} from '../services/getMailAuthLinkWithParamsHooks';
import {CommonLink} from './CommonLink';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const SignUpPromptModal: FC<Props> = (props) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title=""
      size="md"
      padding="xl"
      centered
      onClick={(e) => {
        e.stopPropagation();
      }}
      styles={{
        content: {
          borderRadius: '16px',
        },
        body: {
          padding: '32px 24px',
        },
      }}
    >
      <div className="text-center">
        <Title order={3} className="mb-16 text-black-1 font-bold">
          マイページ機能をご利用いただくには
        </Title>

        <Text className="mb-32 text-black-2 leading-relaxed">
          マイページでは、エントリー情報の管理や
          ES・体験記の閲覧、お気に入り企業のフォローなどができます。
          ぜひアカウントを作成してご活用ください。
        </Text>
      </div>

      <div className="flex flex-col gap-12">
        <CommonLink
          href={mailAuthLink}
          className="flex items-center justify-center font-bold bg-accent-1 text-white rounded-4 p-16 hover:opacity-60"
        >
          <MdPersonAdd className="mr-8" size={24} />
          新規会員登録（無料）
        </CommonLink>

        <CommonLink
          href={LOGIN}
          className="flex items-center justify-center font-bold bg-white text-primary border border-primary rounded-4 p-16 hover:opacity-60"
        >
          <MdLogin className="mr-8" size={24} />
          ログイン
        </CommonLink>
      </div>

      <div className="mt-24 text-center">
        <Text size="sm" className="text-black-3">
          外資就活ドットコムの全ての機能を無料でご利用いただけます
        </Text>
      </div>
    </Modal>
  );
};
